import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiLoader from "../../components/MuiLoader";

// MUI
import {
  Grid,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  IconButton,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {
  usertype_change,
  program_change,
  clas_change,
  level_change,
  subject_change,
  question_change,
  setSelectedQuestion,
} from "./AudioAssessment.Slice";
import {
  get_audio_assessment_question,
  delete_audio_assessment_question,
} from "./AudioAssessment.Thunk";
import CreateQuestion from "./Data.CreateQuestion";

// Toastyfy
import { ToastContainer, toast } from "react-toastify";

// swal
import Swal from "sweetalert2";

// ------------------ AWS S3 Configurations --------------------
import AWS from "aws-sdk";
const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
const REGION = process.env.REACT_APP_REGION;
const ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;
const SECRET_ACCESS_KEY = process.env.REACT_APP_SECRET_ACCESS_KEY;

AWS.config.update({
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
});
const S3 = new AWS.S3({
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
});
// -------------------------------------------------------------

const Data = () => {
  const dispatch = useDispatch();
  // --------- options for dropdowns ---------
  const usertype_select_option_list = [
    { value: "fellow", text: "Fellow" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
  ];
  const program_select_option_list = [
    { value: "ece", text: "ECE" },
    { value: "pge", text: "PGE" },
  ];
  const clas_select_option_list = [
    { value: "1", text: "ଶ୍ରେଣୀ ୧" },
    { value: "2", text: "ଶ୍ରେଣୀ ୨" },
    { value: "3", text: "ଶ୍ରେଣୀ ୩" },
    { value: "4", text: "ଶ୍ରେଣୀ ୪" },
    { value: "5", text: "ଶ୍ରେଣୀ ୫" },
    { value: "6", text: "ଶ୍ରେଣୀ ୬" },
    { value: "7", text: "ଶ୍ରେଣୀ ୭" },
    { value: "8", text: "ଶ୍ରେଣୀ ୮" },
  ];
  const level_select_option_list = [
    { value: "1", text: "Level 1 (Age 3-4 Years)" },
    { value: "2", text: "Level 2 (Age 4-5 Years)" },
    { value: "3", text: "Level 3 (Balvatika)" },
  ];
  const subject_select_option_list = [
    { value: "maths", text: "Maths" },
    { value: "english", text: "English" },
    { value: "odia", text: "Odia" },
  ];
  // ---------------------------------------------

  // ------------ Load data & skill ----------------
  const usertype = useSelector((state) => state.AudioAssessmentSlice.usertype);
  const program = useSelector((state) => state.AudioAssessmentSlice.program);
  const level = useSelector((state) => state.AudioAssessmentSlice.level);
  const subject = useSelector((state) => state.AudioAssessmentSlice.subject);
  const clas = useSelector((state) => state.AudioAssessmentSlice.clas);
  const loading = useSelector((state) => state.AudioAssessmentSlice.loading);
  // -----------------------------------------------
  const data = useSelector((state) => state.AudioAssessmentSlice.data);
  const question_data = useSelector(
    (state) => state.AudioAssessmentSlice.question
  );
  console.log("question_data", question_data);
  // const selectedQuestion = useSelector(
  //   (state) => state.audioAssessment.selectedQuestion
  // );

  // ------------ dropdowns on change ----------------
  const usertpe_select_onchange = (event) => {
    console.log(event.target.value, "line number 110");
    if (event.target.value == null) {
      dispatch(usertype_change(""));
      dispatch(program_change(""));
      dispatch(clas_change(""));
      dispatch(subject_change(""));
      dispatch(get_audio_assessment_question({}));
    } else {
      dispatch(usertype_change(event.target.value));
    }
  };
  const program_select_onchange = (event) => {
    dispatch(program_change(event.target.value));
  };
  const clas_select_onchange = (event) => {
    dispatch(clas_change(event.target.value));
  };
  const level_select_onchange = (event) => {
    console.log(event.target.value, "line number 119");
    dispatch(clas_change(event.target.value));
  };
  const subject_select_onchange = (event) => {
    let obj = { usertype, program, clas, subject: event.target.value };
    dispatch(subject_change(event.target.value));
    dispatch(get_audio_assessment_question(obj));
  };
  //----------------------------------

  //----------------- Create Question Dialog --------------
  const [showCreateQuestionDialog, setShowCreateQuestionDialog] =
    useState(false);
  const open_create_question_dialog = () => {
    dispatch(setSelectedQuestion(null));
    if (usertype == undefined || usertype == null || usertype.trim() == "")
      toast.error("Select Usertype");
    else if (program == undefined || program == null || program.trim() == "")
      toast.error("Select Program");
    else if (clas == undefined || clas == null || clas.trim() == "")
      toast.error("Select Class");
    else if (subject == undefined || subject == null || subject.trim() == "")
      toast.error("Select Subject");
    else setShowCreateQuestionDialog(true);
  };

  const close_create_question_dialog = () => {
    setShowCreateQuestionDialog(false);
    let obj = { usertype, program, clas, subject };
    dispatch(get_audio_assessment_question(obj));
  };
  //-------------------------------------------------------
  const [selectedAssesment, setSelectedAssesment] = useState({});
  const edit_Assessment_Question = (assessmentObj) => {
    setSelectedAssesment(assessmentObj);
    dispatch(setSelectedQuestion(assessmentObj));
    setShowCreateQuestionDialog(true);
  };

  const delete_assessment_question = (assessmentobj) => {
    Swal.fire({
      title: "Confirm delete.",
      text: "Are you sure, you want to delete this assessment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (assessmentobj.questionImage)
          delete_file_from_s3(
            assessmentobj.questionId,
            assessmentobj.questionImage
          );
        else delete_record_from_db(assessmentobj.questionId);
      }
    });
  };

  const delete_file_from_s3 = async (Qid, Qurl) => {
    // get file name from image url
    const parsedUrl = new URL(Qurl);
    const path = parsedUrl.pathname;
    const segments = path.split("/");
    const filename = segments[segments.length - 1];
    console.log("-->filename: ", filename);

    // delete file from s3
    const params = {
      Bucket: S3_BUCKET,
      Key: filename,
    };
    await S3.deleteObject(params, async (err, data) => {
      if (err) {
        toast.error("Error deleting file:", err);
      } else {
        toast.success("File deleted successfully:", filename);
        await delete_record_from_db(Qid);
      }
    });
  };

  const delete_record_from_db = async (Qid) => {
    let obj = { usertype, program, clas, subject };
    await dispatch(delete_audio_assessment_question(Qid));

    dispatch(get_audio_assessment_question(obj));
  };

  return (
    <>
      <div>
        <FormControl sx={{ m: 1, width: 150 }} size="small">
          <InputLabel id="demo-select-small">UserType</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="UserType"
            onChange={usertpe_select_onchange}
          >
            <MenuItem value={null}>None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 150 }} size="small">
          <InputLabel id="demo-select-small">Program</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={program}
            label="Program"
            onChange={program_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype && usertype != ""
              ? program_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))
              : null}
          </Select>
        </FormControl>
        {program == "ece" ? (
          <FormControl sx={{ m: 1, width: 150 }} size="small">
            <InputLabel id="demo-select-small">Level</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={clas}
              label="Level"
              onChange={level_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {usertype && usertype != ""
                ? level_select_option_list.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </FormControl>
        ) : (
          <FormControl sx={{ m: 1, width: 150 }} size="small">
            <InputLabel id="demo-select-small">Class</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={clas}
              label="Class"
              onChange={clas_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {usertype && usertype != ""
                ? clas_select_option_list.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </FormControl>
        )}
        <FormControl sx={{ m: 1, width: 150 }} size="small">
          <InputLabel id="demo-select-small">Subject</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={subject}
            label="Subject"
            onChange={subject_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype && usertype != ""
              ? subject_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))
              : null}
          </Select>
        </FormControl>
        <Button variant="outlined" onClick={open_create_question_dialog}>
          Add Question
        </Button>
      </div>
      <div>
        <Grid container spacing={2}>
          {usertype && usertype != ""
            ? question_data.map((assessment, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card key={index} sx={{ maxWidth: 345, marginBottom: 4 }}>
                    {/* <CardHeader title="Question" /> */}
                    <CardContent>
                      <Typography variant="body2" color="text.secondary">
                        {assessment.question}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {assessment.questionWiseMarks}
                      </Typography>
                    </CardContent>

                    {/* {assessment.questionImage && (
                      <CardMedia
                        component="img"
                        height="194"
                        image={assessment?.questionImage}
                        alt={assessment.questionId}
                      />
                    )} */}
                    {assessment.questionImage ? (
                      <CardMedia
                        component="img"
                        height="194"
                        image={assessment.questionImage}
                        alt={assessment.questionId}
                      />
                    ) : null}
                    <IconButton
                      onClick={() => delete_assessment_question(assessment)}
                      aria-label="delete"
                    >
                      <DeleteIcon />
                    </IconButton>
                    <IconButton aria-label="edit">
                      <EditIcon
                        onClick={() => edit_Assessment_Question(assessment)}
                      />
                    </IconButton>
                  </Card>
                </Grid>
              ))
            : null}
        </Grid>
      </div>

      {/* Create Question Dialog */}
      <CreateQuestion
        S3={S3}
        S3_BUCKET={S3_BUCKET}
        usertype={usertype}
        language="od"
        program={program}
        clas={clas}
        subject={subject}
        open={showCreateQuestionDialog}
        assessment={selectedAssesment}
        onClose={close_create_question_dialog}
      />

      {/* Toaster */}
      <ToastContainer />

      {/* Loader */}
      <MuiLoader open={loading} />
    </>
  );
};
export default Data;
